import jspreadsheet from "jspreadsheet";

const accessRightsSource = ["", "V", "D", "R", "W", "O", "X"];
export const accessRightColors = {
  ACCESS: "#abed92",
  ACCESS_IMPLICIT: "#c6ffb0",
  NO_ACCESS: "#a5a7ac",
  NO_ACCESS_IMPLICIT: "#bbbfc7",
  CONFLICT: "#c8444e",
  CONFLICT_IMPLICIT: "#e8505b",
  SUSPICIOUS: "#dfa450",
  SUSPICIOUS_IMPLICIT: "#febf63",
  UPDATED: "#03a9f4",
};

export const accessRightSetCellColor = function (value: API_ColumnValue, cell: HTMLElement) {
  if (value.implicit) {
    if (accessRightColors[value.type + "_IMPLICIT"]) {
      cell.style.backgroundColor = accessRightColors[value.type + "_IMPLICIT"];
    }
  } else {
    if (accessRightColors[value.type]) {
      cell.style.backgroundColor = accessRightColors[value.type];
    }
  }
};

export const AccessRightsCell: jspreadsheet.Editor = (function () {
  const methods: Partial<jspreadsheet.Editor> & { _validateValue?: Function } = {};
  const editor = document.createElement("input");
  editor.classList.add("jss_object", "jss-input-cell");
  editor.type = "text";
  editor.onpaste = (e) => e.preventDefault();

  let savedValue: string;
  methods.createCell = (cell, value) => {
    if (cell) {
      cell.innerText = value.accessRight;
      accessRightSetCellColor(value, cell);
      return value;
    }
  };

  methods.updateCell = (cell: HTMLTableCellElement, value: API_ColumnValue) => {
    if (cell) {
      if (value !== null && typeof value === "object") {
        cell.innerHTML = value.accessRight;
        accessRightSetCellColor(value, cell);
      } else {
        cell.innerText = value as string;
        cell.style.backgroundColor = accessRightColors.UPDATED;
      }
    }
  };

  methods.openEditor = (cell, value, x, y, instance: jspreadsheet.worksheetInstance) => {
    instance.parent.input.appendChild(editor);
    instance.parent.input.setAttribute("contentEditable", "false");
    editor.value = cell.innerText;
    savedValue = cell.innerText;

    editor.onkeyup = (e: KeyboardEvent) => {
      e.preventDefault();
      methods._validateValue(editor.value);
    };

    // Focus to instantly get entered key
    editor.focus();
    editor.select();

    setTimeout(() => {
      const vUpper = editor.value.toUpperCase();
      if (!accessRightsSource.some((i) => i === vUpper)) {
        editor.value = cell.innerText;
      }
    }, 100);

    editor.onkeydown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        const isValid = methods._validateValue(editor.value);
        if (isValid) {
          instance.closeEditor(cell, true);
        }
      }
    };
  };

  methods._validateValue = (value: string) => {
    const vUpper = value.toUpperCase();
    if (accessRightsSource.some((i) => i === vUpper)) {
      savedValue = vUpper;
      return true;
    } else {
      editor.value = savedValue;
      editor.select();
      return false;
    }
  };

  // Approach with dropdown list
  // methods.openEditor = (cell, cellValue, _x, _y, instance: jspreadsheet.worksheetInstance) => {
  //   const editorWrapper = jspreadsheet.editors.createEditor(
  //     "div",
  //     cell,
  //     cellValue,
  //     instance as jspreadsheet.worksheetInstance
  //   ) as HTMLInputElement;
  //   editorWrapper.innerText = cell.innerText;
  //   editorWrapper.classList.add("jss-dropdown-wrap");

  //   const ul = document.createElement("ul");
  //   ul.classList.add("jss-dropdown");
  //   accessRightsSource.forEach((item) => {
  //     const li = document.createElement("li");
  //     li.textContent = item;
  //     if (item === cell.innerText) {
  //       li.classList.add("selected");
  //     }
  //     ul.appendChild(li);
  //   });
  //   ul.onclick = (e) => {
  //     const targetNode = e.target as HTMLLIElement;
  //     if (targetNode.tagName === "LI") {
  //       const value = targetNode.textContent;
  //       savedValue = value;
  //       editorWrapper.innerText = value;
  //       methods.closeEditor(cell, true, _x, _y, instance, null);
  //     }
  //   };
  //   editorWrapper.parentNode.appendChild(ul);
  // };

  methods.closeEditor = (cell, save, _x, _y, _instance: jspreadsheet.worksheetInstance) => {
    editor.onkeydown = undefined;
    if (save && typeof savedValue === "string") {
      cell.innerHTML = savedValue;
      savedValue = undefined;
    }
    return cell.innerHTML;
  };

  return methods as jspreadsheet.Editor;
})();
